import * as Yup from 'yup';
import { fbValidations, validations } from '../services/validation';

// Schema for creating a campaign
export const createCampaignSchema = Yup.object().shape({
  ad_account_id: validations.uuid,

  name: fbValidations.campaignName,

  objective: fbValidations.objective,

  special_ad_categories: Yup.array().of(Yup.string().required()).default([]),

  status: Yup.string()
    .default('PAUSED')
    .oneOf(['ACTIVE', 'PAUSED'], 'Status must be Active or Paused'),

  // Budget fields (optional - only when using CBO)
  daily_budget: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === '' || Number.isNaN(originalValue) ? null : value
    )
    .min(1, 'Daily budget must be at least $1')
    .test(
      'either-daily-or-lifetime',
      'Cannot set both daily and lifetime budget',
      function (value) {
        const { lifetime_budget } = this.parent;
        if (value && lifetime_budget) {
          return false;
        }
        return true;
      }
    ),

  lifetime_budget: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === '' || Number.isNaN(originalValue) ? null : value
    )
    .min(1, 'Lifetime budget must be at least $1')
    .test(
      'either-daily-or-lifetime',
      'Cannot set both daily and lifetime budget',
      function (value) {
        const { daily_budget } = this.parent;
        if (value && daily_budget) {
          return false;
        }
        return true;
      }
    ),
});

// Schema for updating a campaign
export const updateCampaignSchema = Yup.object().shape({
  name: fbValidations.campaignName.optional(),

  status: Yup.string()
    .optional()
    .oneOf(['ACTIVE', 'PAUSED', 'DELETED', 'ARCHIVED'], 'Invalid status'),

  daily_budget: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === '' || Number.isNaN(originalValue) ? null : value
    )
    .min(1, 'Daily budget must be at least $1'),

  lifetime_budget: Yup.number()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === '' || Number.isNaN(originalValue) ? null : value
    )
    .min(1, 'Lifetime budget must be at least $1'),
});

// Type inference from schema
export type CreateCampaignFormData = Yup.InferType<typeof createCampaignSchema>;
export type UpdateCampaignFormData = Yup.InferType<typeof updateCampaignSchema>;
